/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Used to set the aria-sort accessibility attribute to an element. This is needed because the
 * aria-sort attribute should only be set on an actively-sorted header to either 'ascending' or
 * 'descending'. All other headers should not have an aria-sort attribute at all, and AngularJS
 * does not have a good way of conditionally adding attributes, only setting them to empty string.
 */
class NgAriaSortController {
    constructor($element) {
        this.$element = $element;
    }

    /** @override */
    $onInit() {
        if (this.ariaSort !== '') {
            this.$element.attr('aria-sort', this.ariaSort);
        }
    }

    /** @override */
    $onChanges() {
        this.$element.removeAttr('aria-sort');

        if (this.ariaSort !== '') {
            this.$element.attr('aria-sort', this.ariaSort);
        }
    }
}

NgAriaSortController.$inject = [
    '$element',
];

angular.module('aviApp').directive('ngAriaSort', () => {
    return {
        controller: NgAriaSortController,
        restrict: 'A',
        bindToController: {
            ariaSort: '@?ngAriaSort',
        },
    };
});
